import React, { useEffect, useState } from 'react'
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Link } from 'react-router-dom';
import { useRecoilState, useResetRecoilState } from 'recoil';
import { homeWrapDisplayState } from '../globalStates/home/homeWrapDisplay'
import honeycombQuestImg from '../images/honeycombQuest.png'
import honeycombLogo from '../images/honeycomb.png'
import { getUserData } from '../database/getUserData';
import { userDataState } from '../globalStates/general/userData';
import { userDataUpdateFlagState } from '../globalStates/general/userDataUpdateFlag';
import { changeUserName } from '../database/ChangeUserName';
import { auth } from '../database/firebase';
import { useAuthState } from 'react-firebase-hooks/auth'
import CertificationPage from './Certification/CertificationPage';
import { certificationWindowDisplayState } from '../globalStates/home/certificationWindowDisplay';
import { gameStatusInfoState } from '../globalStates/general/gameStatusInfo';
import { gameStatusState } from '../globalStates/general/gameStatus';
import SignInButton from './Certification/SignInButton';
import SignOutButton from './Certification/SignOut';
import AnonymousSignIn from './Certification/AnonymousSignIn';
import Hamburger from './Hamburger'
import { addSentencesData } from '../database/addSentencesData';
import { useMedia } from 'use-media';

const Home = () => {
  const [user, initialising] = useAuthState(auth);
  const [gameStatusValue, setGameStatusValue] = useRecoilState(gameStatusState);
  const [homeWrapDisplay, setHomeWrapDisplay] = useRecoilState(homeWrapDisplayState);
  const [userData, setUserData] = useRecoilState(userDataState);
  const [userDataUpdateFlag, setUserDataUpdateFlag] = useRecoilState(userDataUpdateFlagState);
  const [certificationDisplay, setCertificationDisplay] = useRecoilState(certificationWindowDisplayState);
  const isPC = useMedia({ minWidth: '1000px' });
  const isHorizontal = useMedia({ orientation: 'landscape' });

  useEffect(() => {
    if (window.innerHeight > window.innerWidth) {
      alert("このアプリは横画面でのみご利用いただけます。");
      window.location.assign('/');
    }
  }, []);



  // 正解の画面から帰ってきたときにリロードしてstateを初期化する
  let url = sessionStorage.getItem('url');
  if (url) {
    if (((url.split("/")[3] === "easy" || url.split("/")[3] === "normal" || url.split("/")[3] === "hard")) || (url.split("/")[4] === "easy" || url.split("/")[4] === "normal" || url.split("/")[4] === "hard")) {
      window.location.reload();
      sessionStorage.setItem('url', null);
    }
  }

  useEffect(() => {
    setHomeWrapDisplay("block");
    setTimeout(() => {
      setHomeWrapDisplay("none");
    }, 3000);
  }, []);

  // データベース上のユーザーデータが変更されたときにユーザーデータを管理しているStateをUpdateする
  useEffect(() => {
    if (user) {
      // stateのアップデート
      getUserData().then((data) => {
        setUserData(data);
      });
    }
  }, [userDataUpdateFlag]);

  useEffect(() => {
    if (user) {
      setCertificationDisplay("none");
      // stateのアップデート
      getUserData().then((data) => {
        setUserData(data);
      });
    }
  }, [user]);

  let homeLoading;
  let homeContainer;
  let honeycombQuestImgStyle;

  if (isPC) {
    homeLoading = css`
    z-index: 1;
    width: 100vw;
    height: 100vh;
    display: ${homeWrapDisplay};
    background-color: white;
    color: #555;
    animation: fadeOut 1s  2s  ease-in forwards;
    text-align: center;
    img {
      margin-top: 150px;
      width: 20%;
      height: auto;

    }

    @keyframes fadeOut {
      from {
        opacity: 1;
      }
      to {
        opacity: 0;
      }
    }
  `;
    homeContainer = css`
      #link-privacy-policy {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0.75em;
        color: gray;

      }
      .pip {
        position: absolute;
        bottom: 70px;
        right: 200px;
      }
      .explain {
        position: absolute;
        bottom: 70px;
        right: 212px;
      }
      .item-explain {
        position: absolute;
        bottom: 70px;
        right: 100px;
      }
      .teacher {
        position: absolute;
        bottom: 40px;
        right: 100px;
      }
      .show-sentence {
        position: absolute;
        bottom: 130px;
        right: 100px;
      }
      .honeycomb-quiz {
        position: absolute;
        bottom: 100px;
        right: 100px;
      }
      text-align: center;
      width: 100vw;
      animation: fadein 1.3s ease-out forwards;
      display: ${homeWrapDisplay == "block" ? "none" : "block"};
      @keyframes fadein {
        0% {opacity: 0}
        100% {opacity: 1}
      }
      div {

        button{
        /*線の基点とするためrelativeを指定*/
          position: relative;
          /*ボタンの形状*/
          display: inline-block;

          padding: 10px 20px;
          background:#eee;
          text-decoration: none;
          outline: none;
          /*アニメーションの指定*/
          transition: all .3s;
          transition-delay: .7s;/*0.7秒遅れてアニメーション*/

          width: 260px;
          height: 60px;
          margin-top: 40px;
          cursor: pointer;
          font-size: 1.3em;
          font-weight: bold;
          background-color: #fff;
          color: #555555;
          border: 0px solid #000;
        }

        /*hoverした際の、ボタンの背景とテキスト色の変更*/
        button:hover{
          background:#333;
          color: #fff;
        }

        /*線の設定*/
        button span{
            display: block;
        }

        /*横線の設定*/
        button::before,
        button::after{
            content:"";
            /*絶対配置で線の位置を決める*/
            position: absolute;
            /*線の形状*/
            width: 0;
            height: 2px;
            background: #333;
            /*アニメーションの指定*/
            transition: all 0.25s linear;
        }

        /*縦線の設定*/
        button span::before,
        button span::after{
            content:"";
            /*絶対配置で線の位置を決める*/
            position: absolute;
            /*線の形状*/
            width:2px;
            height:0;
            background: #333;
            /*アニメーションの指定*/
            transition: all 0.25s linear;
        }

        /*hoverした際、線が縦横100%伸びる*/
        button:hover::before,
        button:hover::after{
            width: 100%;
        }
        button:hover span::before,
        button:hover span::after{
            height: 100%;
        }

        /*== 左下⇒右下⇒右上⇒左上⇒左下に枠線が伸びて塗りに */

        /*左下から右下へ伸びる横線*/
        button::after{
            left: 0;
            bottom: 0;
        }

        /*右下から上へ伸びる縦線*/
        button span::after{
            right: 0;
            bottom: 0;
            transition-delay: 0.3s;
        }

        /*右上から左上へ伸びる横線*/
        button::before{
            right: 0;
            top: 0;
            transition-delay: 0.2s;
        }

        /*左上から左下へ伸びる横線*/
        button span::before{
            left: 0;
            top: 0;
            transition-delay: 0.3s;
        }
      }

    `;
    honeycombQuestImgStyle = css`
      width: 60vw;
      margin-top: 110px;
      margin-bottom: 80px;
    `;
  } else {
    homeLoading = css`
    p {
      padding: 0 30px;
    }

    z-index: 1;
    width: 100vw;
    height: 100vh;
    display: ${homeWrapDisplay};
    background-color: white;
    color: #555;
    animation: fadeOut 1s  2s  ease-in forwards;
    text-align: center;
    img {
      margin-top: 0px;
      width: 40%;
      height: auto;

    }

    @keyframes fadeOut {
      from {
        opacity: 1;
      }
      to {
        opacity: 0;
      }
    }
    `;
    homeContainer = css`
      .sign-out {
          transform: scale(0.7);
          position: absolute;
          bottom: 10px;
          left: 10px;
      }
      #link-privacy-policy {
        position: absolute;
        bottom: 20px;
        left: 50%;
        transform: translateX(-50%);
        font-size: 0.75em;
        color: gray;
      }
      .pip {
        position: absolute;
        bottom: 70px;
        right: 200px;
      }
      .explain {
        position: absolute;
        bottom: 70px;
        right: 212px;
      }
      .item-explain {
        position: absolute;
        bottom: 70px;
        right: 100px;
      }
      .teacher {
        position: absolute;
        bottom: 40px;
        right: 100px;
      }
      .show-sentence {
        position: absolute;
        bottom: 130px;
        right: 100px;
      }
      .honeycomb-quiz {
        position: absolute;
        bottom: 100px;
        right: 100px;
      }
      text-align: center;
      width: 100vw;
      animation: fadein 1.3s ease-out forwards;
      display: ${homeWrapDisplay == "block" ? "none" : "block"};
      @keyframes fadein {
        0% {opacity: 0}
        100% {opacity: 1}
      }
      div {

        button{
        /*線の基点とするためrelativeを指定*/
          position: relative;
          /*ボタンの形状*/
          display: inline-block;

          padding: 10px 20px;
          background:#eee;
          text-decoration: none;
          outline: none;

          width: 130px;
          height: 30px;
          margin-top: 30px;
          cursor: pointer;
          font-size: 1em;
          font-weight: bold;
          background-color: #fff;
          color: #555555;
          border: 0px solid #000;
        }


      }
    `;
    honeycombQuestImgStyle = css`
      width: 60vw;
      margin-top: 50px;
      margin-bottom: 25px;
    `;
  }



  return (
    <>
      <div css={homeLoading}>
        <img src={honeycombLogo} alt="honeycomb logo" /><br />
        <p>スマートフォン、タブレットに対応しました。<br />開発段階のため、予期しない不具合が発生する可能性があります。予めご了承ください。</p>
      </div>
      <CertificationPage display={certificationDisplay} />
      <div css={homeContainer}>
        <Hamburger />
        <img src={honeycombQuestImg} alt="honeycomb questのロゴイメージ" css={honeycombQuestImgStyle} />
        <div>
          {
            user ? (
              <>
                <Link to={`/my_page`}><button onClick={() => {
                  if (window.innerWidth <= 1200 && !window.matchMedia('(display-mode: standalone)').matches) {
                    alert("このアプリはPWA環境でのみご利用いただけます。共有メニューから「ホーム画面に追加」を選択してください。");
                    window.location.assign('https://honeycombquest.web.app/');
                  } else {
                    if (window.innerWidth >= 1200) document.documentElement.requestFullscreen();
                    setGameStatusValue(-1);
                  }

                }}><span>はじめる</span></button></Link><br />
                <Link to={`/teacher/my_page`}><button onClick={() => {
                  if (window.innerWidth <= 1200 && !window.matchMedia('(display-mode: standalone)').matches) {
                    alert("このアプリはPWA環境でのみご利用いただけます。共有メニューから「ホーム画面に追加」を選択してください。");
                    window.location.assign('https://honeycombquest.web.app/');
                  } else {
                    if (window.innerWidth >= 1200) document.documentElement.requestFullscreen();
                    setGameStatusValue(-1);
                  }
                }}><span>学校用</span></button></Link><br />
                <div className='sign-out'>
                  <SignOutButton />
                </div>
              </>
            ) : (
              <>
                <SignInButton />
                <AnonymousSignIn />
              </>
            )
          }
          <br />
        </div>
        {/* <div>
          <a className="show-sentence" target="_blank" rel="noopener noreferrer" href="https://honeycombgrammar.web.app/">登録されている英文</a>
          <a className="honeycomb-quiz" target="_blank" rel="noopener noreferrer" href="https://honeycombgrammar.web.app/quiz">無限ハニカムクイズ</a>
          <a className='explain' target="_blank" href='https://honeycombquest.web.app/explain' >ルール説明</a><span className='pip'>|</span><a className='item-explain' target="_blank" href='https://honeycombquest.web.app/itemExplain'>アイテム説明</a>
          <Link className='teacher' to={`/teacher`}>先生用ページ</Link>
          </div> */}
        <Link to={'privacy_policy'} id="link-privacy-policy">プライバシーポリシー</Link>
      </div>

    </>
  )
}



export default Home
